export const createKey = (str: string | undefined) =>
  typeof str === "undefined"
    ? ""
    : str
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .replace(/-+/g, "-");
